export default __webpack_public_path__ + "static/media/3.bdd44f9e.png";